__webpack_require__.p = "/integral-core/";